/** The settings index: one tap per section, which is how this reads on a phone. */

import { Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import {
  Archive,
  Building2,
  ChevronRight,
  CreditCard,
  Home,
  Package,
  Store,
  Tags,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import { meQuery } from "@/features/auth/session";

const sections = [
  { to: "/settings/workspace", key: "settings.workspace.title", Icon: Home },
  { to: "/settings/businesses", key: "settings.businesses.title", Icon: Building2 },
  { to: "/settings/categories", key: "settings.categories.title", Icon: Tags },
  { to: "/settings/stores", key: "catalog.stores.title", Icon: Store },
  { to: "/settings/products", key: "catalog.products.title", Icon: Package },
  { to: "/settings/billing", key: "billing.title", Icon: CreditCard },
  { to: "/settings/data", key: "data.title", Icon: Archive },
] as const;

export function SettingsPage() {
  const { t } = useTranslation();
  const me = useQuery(meQuery);
  const plan = me.data?.workspace?.plan_name;

  return (
    <section className="space-y-4">
      <h1 className="text-xl font-semibold">{t("nav.settings")}</h1>

      <ul className="divide-y divide-stone-200 overflow-hidden rounded-lg border border-stone-200 bg-white">
        {sections.map(({ to, key, Icon }) => (
          <li key={to}>
            <Link to={to} className="flex min-h-14 items-center gap-3 px-4 py-3 hover:bg-stone-50">
              <Icon className="h-5 w-5 text-stone-400" aria-hidden />
              <span className="flex-1 font-medium text-stone-800">{t(key)}</span>
              <ChevronRight className="h-5 w-5 text-stone-300" aria-hidden />
            </Link>
          </li>
        ))}
      </ul>

      {plan && <p className="px-1 text-sm text-stone-500">{t("settings.onPlan", { plan })}</p>}
    </section>
  );
}
